// extracted by mini-css-extract-plugin
export default {"dimmed":"Dimmed_dimmed__GlKgu"};